<script>

import {
    mapGetters,
    mapActions
} from 'vuex';

import request
    from '@/services/request';

import Catalogue
    from '@/services/catalogue';

import DatePicker
    from 'vue2-datepicker';

import 'vue2-datepicker/index.css';


import ModalFormComponentContracts
    from '@/components/contracts_new/ModaFormComponent.vue';

import ModalBillExternalComponent
    from '@/components/debts_new/ModalBillExternalComponent.vue';

import ModalShowBillExternalDebtComponent
    from '@/components/bill_external/ModalShowBillExternalDebtComponent.vue';

import ModalDebtsBillComponent
    from '@/components/debts_bill/ModalDebtsBillComponent.vue';

import ModarServicesExtrasComponentAll
    from '@/components/debts/ModarServicesExtrasComponentAll.vue';

import ExtraDueWithoutContractModalComponent
    from '@/components/debs_extra/ExtraDueWithoutContractModalComponent.vue';

import ModalBillPayComponent
    from '@/components/debts_new/ModalBillPayComponent.vue';

import ModalExtraTypeSectorComponent
    from '@/components/debs_extra/ModalExtraTypeSectorComponent.vue';

import ModalExtraDebtPaymentsHistory
    from '@/components/debs_extra/ModalExtraDebtPaymentsHistory.vue';

import ModalExtraDebtPaymentForm
    from '@/components/debs_extra/ModalExtraDebtPaymentForm.vue';


import ModalBillExtraWithoutContract
    from '@/components/debts_new/ModalBillExtraWithoutContractComponent.vue';

import ModalShowBillExtraWithoutContractComponent
    from '@/components/bill_external/ModalShowBillExtraWithoutContractComponent.vue';

export default {

    name: 'debts-table',


    components: {

        DatePicker,

        ModalFormComponentContracts,

        ModalBillExternalComponent,

        ModalShowBillExternalDebtComponent,

        ModalDebtsBillComponent,

        ModarServicesExtrasComponentAll,

        ModalBillPayComponent,

        ModalExtraTypeSectorComponent,

        ExtraDueWithoutContractModalComponent,

        ModalExtraDebtPaymentsHistory,

        ModalExtraDebtPaymentForm,

        ModalBillExtraWithoutContract,

        ModalShowBillExtraWithoutContractComponent

    },


    data() {

        return {

            catalogue:
                new Catalogue(),

            buys:
                [],


            load:
                false,

            loadError:
                '',

            errors:
                {},

            page:
                1,

            range:
                false,

            editForm:
                false,

            editPay:
                false,

            editIncrease:
                false,

            send:
                false,

            form: {

                mail:
                    '',

                content:
                    '',

            },

            search: {

                date:
                    '',

                department_id:
                    '',

                building_id:
                    '',

                company_id:
                    '',

                user_id:
                    '',

                source_type:
                    'all',

                is_paid:
                    '',

                payment_period_id: [
                    1,
                    2,
                    3,
                    4,
                    6,
                    7,
                    8,
                    9
                ],

            },

        };

    },


    computed: {

        ...mapGetters({

            authUser:
                'auth/user',

        }),


        displayBuys() {

            return this.buys.filter(buy => {

                if (
                    this.search.source_type !== 'all' &&
                    this.getSourceType(buy) !== this.search.source_type
                ) {
                    return false;
                }

                if (
                    this.search.is_paid !== '' &&
                    Number(buy.is_paid || 0) !== Number(this.search.is_paid)
                ) {
                    return false;
                }

                return true;
            });

        },


        hasActiveFilters() {

            return Boolean(

                this.search.building_id ||

                this.search.company_id ||

                this.search.user_id ||

                this.range

            );

        },


        summary() {

            let result = {

                total:
                    this.displayBuys.length,

                pending:
                    0,

                paid:
                    0,

                amountMXN: 0,
                amountUSD: 0,
                amountUnknown: 0,

            };


            this.displayBuys.forEach(buy => {

                if (this.isPaid(buy)) {

                    result.paid++;

                } else {

                    result.pending++;

                }


                const chargeCurrency = this.getChargeCurrency(buy);
                const amount = this.getExtraTotal(buy);

                if (chargeCurrency === 'USD') {
                    result.amountUSD += amount;
                } else if (chargeCurrency === 'MXN') {
                    result.amountMXN += amount;
                } else {
                    result.amountUnknown += amount;
                }

            });


            return result;

        },

    },


    async mounted() {

        await this.list();

        this.search.date =
            this.moment()
                .format('YYYY-MM');


        await this.catalogue
            .get_buildings();


        await this.catalogue
            .get_companies_all();


        await this.catalogue
            .get_users_profile(7);



    },


    created() {

        Event.$on(
            'event-load-contract_dues',
            this.list
        );

        Event.$on(
            'event-load-extra-dues-without-contract',
            this.list
        );

    },


    beforeDestroy() {

        Event.$off(
            'event-load-contract_dues',
            this.list
        );

        Event.$off(
            'event-load-extra-dues-without-contract',
            this.list
        );

    },


    methods: {

        ...mapActions({

            errorNotification:
                'alert/error',

            successNotification:
                'alert/success',

        }),

        showBillWithoutContract(buy) {

            Event.$emit(
                'event-show-bill-extra-without-contract',
                buy
            );

        },

        showExtraPaymentsHistory(buy) {

            Event.$emit(
                'event-open-extra-debt-payments-history',
                buy
            );

        },


        /*
         * ========================================
         * LISTADO
         * ========================================
         */

        async list(page = 1) {

            // @change de date-picker/select puede pasar un evento o un valor,
            // no necesariamente el número de página que request.list espera.
            const requestedPage = Number(page);
            const safePage = Number.isInteger(requestedPage) && requestedPage > 0
                ? requestedPage
                : 1;

            this.load = true;

            this.loadError = '';


            let search = {
                ...this.search
            };



            const endpoint =
                '/extra_dues';


            try {

                let { data } =
                    await request.list(
                        endpoint,
                        safePage,
                        search
                    );


                this.buys =
                    Array.isArray(data)
                        ? data
                        : [];


            } catch (error) {

                this.buys = [];

                this.loadError =
                    'Revisa tu conexión e intenta nuevamente.';


                this.errorNotification(
                    error
                );


            } finally {

                this.load = false;

            }

        },


        /*
         * ========================================
         * FILTROS
         * ========================================
         */

        resetFilters() {

            this.range =
                false;


            this.search.date =
                this.moment()
                    .format('YYYY-MM');


            this.search.department_id =
                '';


            this.search.building_id =
                '';


            this.search.company_id =
                '';


            this.search.user_id =
                '';


            this.search.source_type =
                'all';


            this.search.is_paid =
                '';


            this.list();

        },


        /*
         * ========================================
         * DATOS DE CLIENTE
         * ========================================
         */

        getSourceType(buy) {

            if (buy && buy.source_type) {
                return buy.source_type;
            }

            if (buy && buy.has_contract === false) {
                return 'without_contract';
            }

            if (buy && !buy.contract_id && !buy.contract) {
                return 'without_contract';
            }

            return 'contract';

        },


        hasContract(buy) {

            return this.getSourceType(buy) === 'contract';

        },


        getRowKey(buy) {

            if (buy && buy.row_key) {
                return buy.row_key;
            }

            return `${this.getSourceType(buy)}-${buy.id}`;

        },


        getContractUser(buy) {

            if (!buy) {
                return null;
            }

            if (
                this.hasContract(buy) &&
                buy.contract &&
                buy.contract.user
            ) {
                return buy.contract.user;
            }

            if (
                !this.hasContract(buy) &&
                buy.user
            ) {
                return buy.user;
            }

            return null;

        },


        getContractUserName(buy) {

            const user = this.getContractUser(buy);

            return user
                ? this.getUserName(user)
                : 'Sin cliente';

        },


        getClientInitials(buy) {

            const user = this.getContractUser(buy);

            if (!user) {
                return '--';
            }

            const firstName = user.name || user.user_nombre || '';
            const lastName = user.last_name || user.user_apellido || '';

            return (
                String(firstName).trim().charAt(0) +
                String(lastName).trim().charAt(0)
            ).toUpperCase() || '--';

        },


        getUserName(user) {

            if (!user) {
                return '';
            }

            return [
                user.name || user.user_nombre,
                user.last_name || user.user_apellido,
            ]
                .filter(Boolean)
                .join(' ')
                .trim();

        },


        /*
         * ========================================
         * ITEMS
         * ========================================
         */

        getExtraItems(buy) {

            if (!buy) {
                return [];
            }

            if (
                Array.isArray(buy.due_items_extras) &&
                buy.due_items_extras.length
            ) {
                return buy.due_items_extras;
            }

            if (
                Array.isArray(buy.items) &&
                buy.items.length
            ) {
                return buy.items;
            }

            if (
                Array.isArray(buy.due_items_rent_only) &&
                buy.due_items_rent_only.length
            ) {
                return buy.due_items_rent_only;
            }

            return [];

        },


        getConceptDescription(item, index = 0) {

            if (!item) {
                return `Concepto ${index + 1}`;
            }

            return (
                item.description ||
                item.name ||
                item.concept ||
                `Concepto ${index + 1}`
            );

        },


        getConceptAmount(item) {

            if (!item) {
                return 0;
            }

            const values = [
                item.final_amount,
                item.total,
                item.amount,
                item.subtotal,
                item.base_amount,
            ];

            const value = values.find(amount => {
                return (
                    amount !== null &&
                    amount !== undefined &&
                    amount !== '' &&
                    !Number.isNaN(Number(amount))
                );
            });

            const amount = Number(value || 0);

            return Number(item.negative || 0) === 1
                ? amount * -1
                : amount;

        },


        getExtraTotal(buy) {

            const items = this.getExtraItems(buy);

            if (items.length) {
                return items.reduce(
                    (total, item) => {
                        return total + this.getConceptAmount(item);
                    },
                    0
                );
            }

            return Number(
                buy && buy.total_due
                    ? buy.total_due
                    : 0
            );

        },


        /*
         * ========================================
         * ESTADOS
         * ========================================
         */

        isPaid(buy) {

            return Number(
                buy && buy.is_paid
                    ? buy.is_paid
                    : 0
            ) === 1;

        },


        getPaidAmount(buy) {

            return Math.max(
                0,
                Number(
                    buy && buy.pay_amount
                        ? buy.pay_amount
                        : 0
                )
            );

        },


        getPendingAmount(buy) {

            return Math.max(
                0,
                this.getExtraTotal(buy) -
                this.getPaidAmount(buy)
            );

        },


        getPaymentProgress(buy) {

            const total =
                Number(
                    this.getExtraTotal(buy) || 0
                );

            if (total <= 0) {
                return 0;
            }

            const paid =
                this.getPaidAmount(buy);

            return Math.min(
                100,
                Math.max(
                    0,
                    Math.round(
                        (
                            paid /
                            total
                        ) * 100
                    )
                )
            );

        },


        getPaymentStatus(buy) {

            if (this.isPaid(buy)) {
                return 'paid';
            }

            if (
                this.getPaidAmount(buy) > 0
            ) {
                return 'partial';
            }

            return 'pending';

        },


        getStatusText(buy) {

            const status =
                this.getPaymentStatus(buy);

            if (
                status === 'paid'
            ) {
                return 'Pagado';
            }

            if (
                status === 'partial'
            ) {
                return 'Pago parcial';
            }

            return 'Pendiente';

        },


        getStatusBadgeClass(buy) {

            const status =
                this.getPaymentStatus(buy);

            if (
                status === 'paid'
            ) {
                return 'badge-paid';
            }

            if (
                status === 'partial'
            ) {
                return 'badge-partial';
            }

            return 'badge-pending';

        },


        getStatusIcon(buy) {

            const status =
                this.getPaymentStatus(buy);

            if (
                status === 'paid'
            ) {
                return 'fa-solid fa-check';
            }

            if (
                status === 'partial'
            ) {
                return 'fa-solid fa-layer-group';
            }

            return 'fa-solid fa-clock';

        },


        getPaymentProgressClass(buy) {

            const status =
                this.getPaymentStatus(buy);

            if (
                status === 'paid'
            ) {
                return 'payment-progress-bar--paid';
            }

            if (
                status === 'partial'
            ) {
                return 'payment-progress-bar--partial';
            }

            return 'payment-progress-bar--pending';

        },


        getRowClass(buy) {

            const status =
                this.getPaymentStatus(buy);

            return {

                'row-paid':
                    status === 'paid',

                'row-partial':
                    status === 'partial',

                'row-pending':
                    status === 'pending',

            };

        },


        /*
         * ========================================
         * FACTURACIÓN
         * ========================================
         */

        externalBillsLength(buy) {

            return Array.isArray(
                buy && buy.bill_external
            )
                ? buy.bill_external.length
                : 0;

        },


        hasExternalBills(buy) {

            return this.externalBillsLength(buy) > 0;

        },

        isCanceledInvoice(invoice) {
            const status = String(invoice && invoice.status || '')
                .trim()
                .toLowerCase();

            return ['canceled', 'cancelled', 'cancelado', 'cancelada']
                .indexOf(status) !== -1;
        },

        getActiveExternalBills(buy) {
            return Array.isArray(buy && buy.bill_external)
                ? buy.bill_external.filter(invoice => !this.isCanceledInvoice(invoice))
                : [];
        },

        // Conservamos el historial completo (incluidos CFDI cancelados)
        // para no permitir eliminar un cargo con registros fiscales previos.
        canEditExtraDue(buy) {
            return !this.isPaid(buy) && !this.hasExternalBills(buy);
        },

        // Modal fiscal completo, independiente del visor de contratos.
        showExtraInvoices(buy) {
            Event.$emit('event-show-extra-invoice-details', buy);
        },

        getChargeCurrency(buy) {
            const currencyId = Number(this.hasContract(buy)
                ? (buy.contract && buy.contract.currency_id)
                : (buy && buy.currency_id));

            if (currencyId === 1) return 'MXN';
            if (currencyId === 2) return 'USD';
            return '—';
        },


        hasForeignBills(buy) {

            return Number(
                buy && buy.contract_dues_bill_count
                    ? buy.contract_dues_bill_count
                    : 0
            ) > 0;

        },


        getBillItems(buy) {

            const items = this.getExtraItems(buy);

            // Los ajustes negativos siguen visibles en el desglose del cargo,
            // pero no son conceptos facturables en el modal independiente.
            return this.hasContract(buy)
                ? items
                : items.filter(item => Number(item.negative || 0) !== 1);

        },


        getBillItemsCount(buy) {

            return this.getBillItems(buy).length;

        },


        isItemBilled(item) {

            if (!item) {
                return false;
            }

            /*
             * item_bill es la relación que ya utiliza
             * el modal de facturación para excluir
             * conceptos previamente facturados.
             *
             * Los otros campos se dejan como respaldo
             * por si el endpoint carga la relación con
             * otro alias.
             */
            return Boolean(
                item.is_billed === true ||
                Number(item.is_billed) === 1 ||
                item.item_bill ||
                item.bill_external_item ||
                item.bill_external_item_id
            );

        },


        getPendingBillItems(buy) {

            return this
                .getBillItems(buy)
                .filter(item => !this.isItemBilled(item));

        },


        getPendingBillItemsCount(buy) {

            return this.getPendingBillItems(buy).length;

        },


        getBilledItems(buy) {

            return this
                .getBillItems(buy)
                .filter(item => this.isItemBilled(item));

        },


        getBilledItemsCount(buy) {

            return this.getBilledItems(buy).length;

        },


        canCreateBill(buy) {

            // El facturador independiente solo permite conceptos pendientes.
            if (!this.hasContract(buy)) {
                return this.getPendingBillItemsCount(buy) > 0;
            }

            /*
             * Si ya existe una factura foránea/manual
             * conservamos la restricción anterior para
             * no mezclar ambos procesos.
             */
            if (this.hasForeignBills(buy)) {
                return false;
            }

            /*
             * Una factura externa previa ya no bloquea
             * todo el adeudo. Se puede seguir facturando
             * mientras queden conceptos pendientes.
             */
            return this.getPendingBillItemsCount(buy) > 0;

        },


        getBillingStatus(buy) {

            const total =
                this.getBillItemsCount(buy);

            const pending =
                this.getPendingBillItemsCount(buy);

            const billed =
                this.getBilledItemsCount(buy);

            // Las facturas canceladas se muestran en el historial, pero no
            // convierten el adeudo en facturado ni impiden refacturar.
            const external =
                this.getActiveExternalBills(buy).length;


            if (
                this.hasForeignBills(buy) &&
                external === 0
            ) {
                return 'foreign';
            }


            if (
                total > 0 &&
                pending === 0 &&
                (
                    external > 0 ||
                    billed > 0
                )
            ) {
                return 'billed';
            }


            if (
                total > 0 &&
                pending > 0 &&
                (
                    external > 0 ||
                    billed > 0
                )
            ) {
                return 'partial';
            }


            return 'pending';

        },


        getBillingStatusText(buy) {

            const labels = {
                pending:
                    'Sin facturar',

                partial:
                    'Facturado parcial',

                billed:
                    'Facturado',

                foreign:
                    'Factura foránea',

                not_applicable:
                    'No aplica',
            };


            return labels[
                this.getBillingStatus(buy)
            ] || 'Sin facturar';

        },


        getBillingStatusIcon(buy) {

            const icons = {
                pending:
                    'fa-regular fa-clock',

                partial:
                    'fa-solid fa-circle-half-stroke',

                billed:
                    'fa-solid fa-file-circle-check',

                foreign:
                    'fa-solid fa-file-import',

                not_applicable:
                    'fa-solid fa-minus',
            };


            return icons[
                this.getBillingStatus(buy)
            ] || 'fa-regular fa-clock';

        },


        getBillingStatusClass(buy) {

            const status =
                this.getBillingStatus(buy);


            return {

                'billing-badge--pending':
                    status === 'pending',

                'billing-badge--partial':
                    status === 'partial',

                'billing-badge--billed':
                    status === 'billed',

                'billing-badge--foreign':
                    status === 'foreign',

            };

        },


        getCreateBillLabel(buy) {

            return (
                this.getActiveExternalBills(buy).length > 0 ||
                this.getBilledItemsCount(buy) > 0
            )
                ? 'Facturar pendientes'
                : 'Facturar adeudo';

        },


        getCreateBillTitle(buy) {

            const pending =
                this.getPendingBillItemsCount(buy);


            if (
                this.getActiveExternalBills(buy).length > 0 ||
                this.getBilledItemsCount(buy) > 0
            ) {

                return pending === 1
                    ? 'Facturar 1 concepto pendiente'
                    : `Facturar ${pending} conceptos pendientes`;

            }


            return 'Facturar adeudo';

        },


        /*
         * ========================================
         * EVENTOS
         * ========================================
         */

        extraServices() {

            // Event.$emit(
            //     'event-list-extra-services-all'
            // );

            Event.$emit(
                'event-open-extra-type-selector'
            );

        },


        showNewContracts(
            contract_id
        ) {

            Event.$emit(
                'event-show-showContractID',
                contract_id
            );

        },


        showBill(buy) {

            if (!this.canCreateBill(buy)) {
                return;
            }

            if (!this.hasContract(buy)) {
                this.showBillWithoutContract(buy);
                return;
            }

            Event.$emit(
                'event-show-addCreateBillExternals',
                buy
            );

        },


        showBillExternal(buy) {

            if (!this.hasContract(buy)) {
                this.showExtraInvoices(buy);
                return;
            }

            // El visor original sigue reservado a facturas con contrato.
            Event.$emit(
                'event-show-bill-external-dev',
                buy
            );

        },


        showBillDebs(id) {

            Event.$emit(
                'event-show-addCreateBillDebts',
                id
            );

        },


        showBillExternalPay(buy) {
            Event.$emit(
                'event-open-extra-debt-payments-history',
                buy
            );

        },

        editExtraDue(buy) {

            if (!this.canEditExtraDue(buy)) {
                return;
            }

            Event.$emit(
                'event-edit-extra-due-without-contract',
                buy.id
            );

        },


        deleteExtraDue(buy) {

            if (!this.canEditExtraDue(buy)) {

                this.errorNotification({
                    response: {
                        data: {
                            message:
                                'No se puede eliminar un adeudo pagado o con historial de facturación.'
                        }
                    }
                });

                return;
            }

            this.$swal({
                title:
                    'Eliminar adeudo',
                text:
                    '¿Deseas eliminar este adeudo extra?',
                icon:
                    'warning',
                showCancelButton:
                    true,
                confirmButtonColor:
                    '#d33',
                cancelButtonColor:
                    '#6c757d',
                confirmButtonText:
                    'Sí, eliminar',
                cancelButtonText:
                    'Cancelar',
                reverseButtons:
                    true,
            }).then(async result => {

                if (!result.isConfirmed) {
                    return;
                }

                try {

                    let { data } =
                        await request.destroy(
                            '/extra_dues/' + buy.id
                        );

                    this.successNotification(
                        data.message
                    );

                    this.list();

                } catch (error) {

                    this.errors =
                        await this.errorNotification(
                            error
                        );
                }

            });

        },

    },


    watch: {

        range(value) {

            if (value) {

                const monthIni =
                    this.moment()
                        .format(
                            'YYYY-MM'
                        );


                const monthEnd =
                    this.moment()
                        .add(
                            1,
                            'M'
                        )
                        .format(
                            'YYYY-MM'
                        );


                this.search.date = [
                    monthIni,
                    monthEnd
                ];


            } else {

                this.search.date =
                    this.moment()
                        .format(
                            'YYYY-MM'
                        );

            }

            this.list();

        },

    },

};
</script>

<template>
    <div class="col-12 debts-extra-page">
        <!-- ==========================================
             MODALES
        =========================================== -->

        <ModarServicesExtrasComponentAll :prop_edit="true" />

        <ModalFormComponentContracts :prop_edit="false" />

        <ModalBillExternalComponent />

        <ModalShowBillExternalDebtComponent />

        <ModalDebtsBillComponent />

        <ModalBillPayComponent />

        <ModalExtraTypeSectorComponent />

        <ExtraDueWithoutContractModalComponent />

        <ModalExtraDebtPaymentsHistory />

        <ModalExtraDebtPaymentForm />

        <ModalBillExtraWithoutContract />

        <!-- Detalle completo de facturas sin contrato -->
        <ModalShowBillExtraWithoutContractComponent />

        <!-- ==========================================
             CARD PRINCIPAL
        =========================================== -->

        <div class="card card-outline card-secondary">
            <!-- ======================================
                 ENCABEZADO
            ======================================= -->

            <div class="card-header">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                        <h3 class="card-title mb-0">
                            <i class="fa-solid fa-file-invoice-dollar mr-2"></i>

                            Lista de otros ingresos
                        </h3>

                        <br />

                        <small class="text-muted d-block mt-1">
                            Consulta, factura y administra cargos extraordinarios.
                        </small>
                    </div>

                    <div class="card-tools mt-2 mt-md-0">
                        <button type="button" class="btn btn-sm btn-outline-success" @click="extraServices">
                            <i class="fa-solid fa-plus mr-1"></i>

                            Nuevo cargo
                        </button>
                    </div>
                </div>
            </div>

            <!-- ======================================
                 BODY
            ======================================= -->

            <div class="card-body">
                <!-- ==================================
                     LISTADO UNIFICADO
                =================================== -->

                <!-- ==============================
                         FILTROS
                    =============================== -->

                <div class="filters-panel">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <h6 class="mb-0 font-weight-bold">
                            <i class="fa-solid fa-filter mr-1"></i>

                            Filtros
                        </h6>

                        <button v-if="hasActiveFilters" type="button" class="btn btn-sm btn-link text-danger p-0"
                            @click="resetFilters">
                            <i class="fa-solid fa-xmark mr-1"></i>

                            Limpiar filtros
                        </button>
                    </div>

                    <div class="row">
                        <!-- PERIODO -->

                        <div class="col-lg-3 col-md-6 mb-3">
                            <label> Periodo </label>

                            <date-picker format="YYYY-MM" :range="range" valueType="format" type="month"
                                :clearable="false" v-model="search.date" @change="list" class="w-100" :disabled="load">
                            </date-picker>
                        </div>

                        <!-- PROPIEDAD -->

                        <div class="col-lg-3 col-md-6 mb-3">
                            <label> Propiedad </label>

                            <select v-model="search.building_id
                                " class="form-control" :disabled="load" @change="list">
                                <option value="">Todas las propiedades</option>

                                <option v-for="
building
    in catalogue.buildings
                                        " :key="building.id" :value="building.id">
                                    {{ building.name }}
                                </option>
                            </select>
                        </div>

                        <!-- CLIENTE -->

                        <div class="col-lg-3 col-md-6 mb-3">
                            <label> Cliente </label>

                            <select v-model="search.user_id
                                " class="form-control" :disabled="load" @change="list">
                                <option value="">Todos los clientes</option>

                                <option v-for="
user
    in catalogue.users_profile
                                        " :key="user.id" :value="user.id">
                                    {{
                                        getUserName(user)
                                    }}
                                </option>
                            </select>
                        </div>

                        <!-- EMPRESA -->

                        <div class="col-lg-3 col-md-6 mb-3">
                            <label> Empresa </label>

                            <select v-model="search.company_id
                                " class="form-control" :disabled="load" @change="list">
                                <option value="">Todas las empresas</option>

                                <option v-for="
company
    in catalogue.companies_all
                                        " :key="company.id" :value="company.id">
                                    {{ company.name }}
                                </option>
                            </select>
                        </div>

                        <!-- TIPO DE CARGO -->

                        <div class="col-lg-3 col-md-6 mb-3">
                            <label> Tipo de cargo </label>

                            <select v-model="search.source_type" class="form-control" :disabled="load" @change="list">
                                <option value="all">Todos</option>

                                <option value="contract">Con contrato</option>

                                <option value="without_contract">Sin contrato</option>
                            </select>
                        </div>

                        <!-- ESTATUS -->

                        <div class="col-lg-3 col-md-6 mb-3">
                            <label> Estatus </label>

                            <select v-model="search.is_paid" class="form-control" :disabled="load" @change="list">
                                <option value="">Todos los estatus</option>

                                <option value="0">Pendientes</option>

                                <option value="1">Pagados</option>
                            </select>
                        </div>

                        <!-- RANGO -->

                        <div class="col-12">
                            <label class="range-option mb-0">
                                <input type="checkbox" v-model="range" :disabled="load" />

                                <span> Consultar rango de meses </span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- ==============================
                         RESUMEN
                    =============================== -->

                <div class="row summary-section">
                    <!-- TOTAL -->

                    <div class="col-lg-3 col-md-6 mb-3">
                        <div class="summary-card summary-total">
                            <div class="summary-icon">
                                <i class="fa-solid fa-file-lines"></i>
                            </div>

                            <div>
                                <span class="summary-label"> Total mostrado </span>

                                <strong class="summary-value">
                                    {{ summary.total }}
                                </strong>
                            </div>
                        </div>
                    </div>

                    <!-- PENDIENTES -->

                    <div class="col-lg-3 col-md-6 mb-3">
                        <div class="summary-card summary-pending">
                            <div class="summary-icon">
                                <i class="fa-solid fa-clock"></i>
                            </div>

                            <div>
                                <span class="summary-label"> Pendientes </span>

                                <strong class="summary-value">
                                    {{ summary.pending }}
                                </strong>
                            </div>
                        </div>
                    </div>

                    <!-- PAGADOS -->

                    <div class="col-lg-3 col-md-6 mb-3">
                        <div class="summary-card summary-paid">
                            <div class="summary-icon">
                                <i class="fa-solid fa-check"></i>
                            </div>

                            <div>
                                <span class="summary-label"> Pagados </span>

                                <strong class="summary-value">
                                    {{ summary.paid }}
                                </strong>
                            </div>
                        </div>
                    </div>

                    <!-- MONTO -->

                    <div class="col-lg-3 col-md-6 mb-3">
                        <div class="summary-card summary-amount">
                            <div class="summary-icon">
                                <i class="fa-solid fa-dollar-sign"></i>
                            </div>

                            <div>
                                <span class="summary-label"> Monto mostrado por moneda </span>

                                <strong class="summary-value summary-money" v-if="summary.amountMXN || !summary.amountUSD">
                                    {{ summary.amountMXN | toCurrency }} MXN
                                </strong>
                                <strong class="summary-value summary-money" v-if="summary.amountUSD">
                                    {{ summary.amountUSD | toCurrency }} USD
                                </strong>
                                <small v-if="summary.amountUnknown" class="text-warning d-block">
                                    Hay importes sin moneda definida; no se sumaron a MXN/USD.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ==============================
                         TABLA
                    =============================== -->

                <div class="table-container debts-list-container">
                    <div class="table-responsive">
                        <table
                            class="table table-bordered table-hover text-center text-sm debts-table debts-table-compact">
                            <thead>
                                <tr>
                                    <th class="column-id">ID</th>

                                    <th class="column-data">DATOS</th>

                                    <th class="column-date">FECHA</th>

                                    <th class="column-payment">PAGO</th>
                                    <th class="column-actions">OPCIONES</th>
                                </tr>
                            </thead>

                            <tbody>
                                <!-- ======================
                                         CARGANDO
                                    ======================= -->

                                <tr v-if="load">
                                    <td colspan="5" class="loading-cell">
                                        <div class="loading-content">
                                            <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-3"></i>

                                            <h5 class="mb-1">Cargando adeudos</h5>

                                            <small class="text-muted"> Espera un momento... </small>
                                        </div>
                                    </td>
                                </tr>

                                <!-- ======================
                                         ERROR
                                    ======================= -->

                                <tr v-else-if="loadError">
                                    <td colspan="5" class="empty-cell">
                                        <div class="empty-state text-danger">
                                            <i class="fa-solid fa-triangle-exclamation fa-3x mb-3"></i>

                                            <h5>No se pudo cargar la información</h5>

                                            <p class="mb-3">
                                                {{ loadError }}
                                            </p>

                                            <button type="button" class="btn btn-sm btn-outline-primary" @click="list">
                                                <i class="fa-solid fa-rotate-right mr-1"></i>

                                                Volver a intentar
                                            </button>
                                        </div>
                                    </td>
                                </tr>

                                <!-- ======================
                                         RESULTADOS
                                    ======================= -->

                                <template v-else-if="displayBuys.length">
                                    <tr v-for="buy in displayBuys" :key="getRowKey(buy)" :class="getRowClass(buy)">
                                        <!-- ID -->

                                        <td class="column-id">
                                            <div class="debt-id-card">
                                                <div class="debt-id">#{{ buy.id }}</div>

                                                <small v-if="hasContract(buy)" class="debt-contract-id">
                                                    Contrato #{{ buy.contract_id }}
                                                </small>

                                                <small v-else class="debt-contract-id">
                                                    Cargo sin contrato
                                                </small>

                                                <span class="badge status-badge debt-status debt-status--id"
                                                    :class="getStatusBadgeClass(buy)">
                                                    <i class="mr-1" :class="getStatusIcon(buy)"></i>
                                                    {{ getStatusText(buy) }}
                                                </span>

                                                <div class="billing-state">
                                                    <span
                                                        class="badge billing-badge"
                                                        :class="getBillingStatusClass(buy)"
                                                    >
                                                        <i
                                                            class="mr-1"
                                                            :class="getBillingStatusIcon(buy)"
                                                        ></i>

                                                        {{ getBillingStatusText(buy) }}
                                                    </span>

                                                    <small
                                                        v-if="getBillItemsCount(buy) > 0"
                                                        class="billing-state__detail"
                                                    >
                                                        {{ getBilledItemsCount(buy) }}
                                                        de
                                                        {{ getBillItemsCount(buy) }}
                                                        conceptos
                                                    </small>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- DATOS -->

                                        <td class="column-data">
                                            <div class="debt-data">
                                                <div class="debt-data-header">
                                                    <div v-if="hasContract(buy)" class="debt-property">
                                                        <i class="fa-regular fa-building mr-1"></i>

                                                        <span v-if="buy.contract && buy.contract.building">
                                                            {{ buy.contract.building.name }}
                                                        </span>

                                                        <span v-else class="text-muted">
                                                            Sin propiedad
                                                        </span>
                                                    </div>

                                                    <div v-else class="debt-property debt-property--without">
                                                        <i class="fa-regular fa-file-lines mr-1"></i>
                                                        Cargo independiente
                                                    </div>

                                                    <span class="source-badge"
                                                        :class="hasContract(buy) ? 'source-badge--contract' : 'source-badge--without'">
                                                        <i class="mr-1"
                                                            :class="hasContract(buy) ? 'fa-solid fa-file-contract' : 'fa-regular fa-file-lines'"></i>
                                                        {{ hasContract(buy) ? 'Con contrato' : 'Sin contrato' }}
                                                    </span>
                                                </div>

                                                <!-- CLIENTE -->

                                                <div v-if="getContractUser(buy)" class="debt-client">
                                                    <div class="client-avatar client-avatar-small">
                                                        {{ getClientInitials(buy) }}
                                                    </div>

                                                    <div class="debt-client-information">
                                                        <strong>
                                                            {{ getContractUserName(buy) }}
                                                        </strong>

                                                        <small class="text-muted d-block">
                                                            {{ hasContract(buy) ? 'Arrendatario' : 'Cliente' }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <div v-else class="debt-client debt-client-empty">
                                                    <div class="client-avatar client-avatar-small client-avatar-empty">
                                                        --
                                                    </div>

                                                    <div class="debt-client-information">
                                                        <strong class="text-muted"> Sin cliente </strong>
                                                    </div>
                                                </div>

                                                <!-- INDIVISOS: SOLO CON CONTRATO -->

                                                <div v-if="
                                                    hasContract(buy) &&
                                                    buy.contract &&
                                                    buy.contract.contract_departments &&
                                                    buy.contract.contract_departments.length
                                                " class="debt-departments">
                                                    <span v-for="department in buy.contract.contract_departments"
                                                        :key="department.id" class="debt-department">
                                                        <i class="fa-solid fa-door-open mr-1"></i>

                                                        <template v-if="department.department">
                                                            {{ department.department.number }}
                                                            <small>
                                                                · Nivel {{ department.department.level }}
                                                            </small>
                                                        </template>

                                                        <template v-else>
                                                            Indiviso #{{ department.department_id }}
                                                        </template>
                                                    </span>
                                                </div>

                                                <!-- DESCRIPCIÓN: SOLO SIN CONTRATO -->

                                                <div v-if="!hasContract(buy) && buy.description"
                                                    class="debt-description">
                                                    <div class="debt-description-label">
                                                        <i class="fa-solid fa-align-left mr-1"></i>
                                                        Descripción
                                                    </div>

                                                    <div class="debt-description-text">
                                                        {{ buy.description }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- FECHA -->

                                        <td class="column-date">
                                            <div v-if="buy.due_date" class="debt-date">
                                                <div class="debt-date-icon">
                                                    <i class="fa-regular fa-calendar"></i>
                                                </div>

                                                <div>
                                                    <strong>
                                                        {{ buy.due_date | toDateTime }}
                                                    </strong>
                                                    <small class="text-muted d-block">
                                                        Fecha de adeudo
                                                    </small>
                                                </div>
                                            </div>

                                            <span v-else class="text-muted"> Sin fecha </span>
                                        </td>

                                        <!-- PAGO -->

                                        <td class="column-payment">
                                            <div class="payment-panel">
                                                <div class="payment-panel-main">
                                                    <div class="payment-panel-top">
                                                        <div class="payment-total-box">
                                                            <small class="payment-section-label">
                                                                Total del adeudo
                                                            </small>

                                                            <strong class="payment-total-value">
                                                                {{ getExtraTotal(buy) | toCurrency }} {{ getChargeCurrency(buy) }}
                                                            </strong>
                                                        </div>

                                                        <div class="payment-amount-grid">
                                                            <div class="payment-amount-item payment-amount-item--paid">
                                                                <small>Pagado</small>
                                                                 <strong>{{ getPaidAmount(buy) | toCurrency }} {{ getChargeCurrency(buy) }}</strong>
                                                            </div>

                                                            <div
                                                                class="payment-amount-item payment-amount-item--pending">
                                                                <small>Saldo pendiente</small>
                                                                <strong>{{ getPendingAmount(buy) | toCurrency }}
                                                                     {{ getChargeCurrency(buy) }}</strong>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="payment-progress-wrap">
                                                        <div class="payment-progress-header">
                                                            <small class="payment-section-label">
                                                                Avance del pago
                                                            </small>

                                                            <strong class="payment-progress-percent">
                                                                {{ getPaymentProgress(buy) }}%
                                                            </strong>
                                                        </div>

                                                        <div class="payment-progress">
                                                            <div class="payment-progress-bar"
                                                                :class="getPaymentProgressClass(buy)" :style="{
                                                                    width: getPaymentProgress(buy) + '%'
                                                                }"></div>
                                                        </div>
                                                    </div>

                                                    <div class="payment-concepts-card">
                                                        <div class="payment-concepts-header">
                                                            <div class="payment-concepts-title">
                                                                <i class="fa-solid fa-list-check mr-1"></i>
                                                                Conceptos del cargo
                                                            </div>

                                                            <small v-if="getExtraItems(buy).length"
                                                                class="payment-concepts-count">
                                                                {{ getExtraItems(buy).length }}
                                                                {{ getExtraItems(buy).length === 1 ? 'concepto' :
                                                                    'conceptos' }}
                                                            </small>
                                                        </div>

                                                        <div v-if="getExtraItems(buy).length"
                                                            class="payment-concepts-list">
                                                            <div v-for="(item, index) in getExtraItems(buy)"
                                                                :key="item.id || item.item_id || index"
                                                                class="payment-concept-row">
                                                                <span class="payment-concept-description"
                                                                    :title="getConceptDescription(item, index)">
                                                                    <span
                                                                        v-if="Number(item.negative || 0) !== 1"
                                                                        class="concept-billing-dot"
                                                                        :class="{
                                                                            'concept-billing-dot--billed': isItemBilled(item),
                                                                            'concept-billing-dot--pending': !isItemBilled(item)
                                                                        }"
                                                                        :title="
                                                                            isItemBilled(item)
                                                                                ? 'Concepto facturado'
                                                                                : 'Concepto pendiente de facturar'
                                                                        "
                                                                    ></span>

                                                                    <span class="payment-concept-index">
                                                                        {{ index + 1 }}.
                                                                    </span>

                                                                    {{ getConceptDescription(item, index) }}
                                                                </span>

                                                                <div class="payment-concept-right">
                                                                    <strong class="payment-concept-amount">
                                                                        {{ getConceptAmount(item) | toCurrency }} {{ getChargeCurrency(buy) }}
                                                                    </strong>

                                                                    <small
                                                                        v-if="Number(item.negative || 0) !== 1"
                                                                        class="payment-concept-billing"
                                                                        :class="{
                                                                            'payment-concept-billing--billed': isItemBilled(item),
                                                                            'payment-concept-billing--pending': !isItemBilled(item)
                                                                        }"
                                                                    >
                                                                        {{
                                                                            isItemBilled(item)
                                                                                ? 'Facturado'
                                                                                : 'Pendiente'
                                                                        }}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <small v-else class="text-muted">
                                                            Sin conceptos registrados
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="payment-panel-actions">
                                                <div class="dropdown debt-options">
                                                    <button type="button"
                                                        class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false">
                                                        <i class="fa-solid fa-ellipsis mr-1"></i>
                                                        Opciones
                                                    </button>

                                                    <div class="dropdown-menu dropdown-menu-right debt-options-menu">
                                                        <!-- CON CONTRATO -->

                                                        <template v-if="hasContract(buy)">
                                                            <button type="button" class="dropdown-item"
                                                                @click="showNewContracts(buy.contract_id)">
                                                                <i class="fa-solid fa-file-contract"></i>
                                                                Consultar contrato
                                                            </button>

                                                            <button
                                                                v-if="canCreateBill(buy)"
                                                                type="button"
                                                                class="dropdown-item"
                                                                :title="getCreateBillTitle(buy)"
                                                                @click="showBill(buy)"
                                                            >
                                                                <i class="fa-solid fa-file-invoice"></i>
                                                                {{ getCreateBillLabel(buy) }}
                                                            </button>

                                                            <button
                                                                v-if="hasExternalBills(buy)"
                                                                type="button"
                                                                class="dropdown-item"
                                                                @click="showBillExternal(buy)"
                                                            >
                                                                <i class="fa-solid fa-layer-group"></i>

                                                                Consultar facturas

                                                                <span class="dropdown-count-badge">
                                                                    {{ externalBillsLength(buy) }}
                                                                </span>
                                                            </button>

                                                            <button
                                                                v-if="!hasExternalBills(buy)"
                                                                type="button"
                                                                class="dropdown-item"
                                                                @click="showBillDebs(buy.id)"
                                                            >
                                                                <i class="fa-solid fa-file-lines"></i>
                                                                Facturas foráneas
                                                            </button>

                                                            <div v-if="!isPaid(buy)" class="dropdown-divider"></div>

                                                            <button v-if="!isPaid(buy)" type="button"
                                                                class="dropdown-item text-success"
                                                                @click="showBillExternalPay(buy)">
                                                                <i class="fa-solid fa-wallet"></i>
                                                                Registrar pago
                                                            </button>

                                                            <button v-if="getPaidAmount(buy) > 0" type="button"
                                                                class="dropdown-item"
                                                                @click="showExtraPaymentsHistory(buy)">
                                                                <i class="fa-solid fa-clock-rotate-left"></i>
                                                                Historial de pagos
                                                            </button>
                                                           
                                                        </template>

                                                        <!-- SIN CONTRATO -->

                                                        <template v-else>

                                                            <button
                                                                v-if="canCreateBill(buy)"
                                                                type="button"
                                                                class="dropdown-item"
                                                                :title="getCreateBillTitle(buy)"
                                                                @click="showBillWithoutContract(buy)"
                                                            >
                                                                <i class="fa-solid fa-file-invoice"></i>
                                                                {{ getCreateBillLabel(buy) }}
                                                            </button>

                                                            <button v-if="hasExternalBills(buy)" type="button"
                                                                class="dropdown-item" @click="showBillExternal(buy)">
                                                                <i class="fa-solid fa-layer-group"></i>
                                                                Consultar facturas
                                                                <span class="dropdown-count-badge">
                                                                    {{ externalBillsLength(buy) }}
                                                                </span>
                                                            </button>

                                                            <button type="button" class="dropdown-item"
                                                                :disabled="!canEditExtraDue(buy)" @click="editExtraDue(buy)">
                                                                <i class="fa-solid fa-pen-to-square"></i>
                                                                Editar adeudo
                                                            </button>                                                           

                                                            <div class="dropdown-divider"></div>

                                                            <button type="button" class="dropdown-item text-danger"
                                                                :disabled="!canEditExtraDue(buy)" @click="deleteExtraDue(buy)">
                                                                <i class="fa-solid fa-trash"></i>
                                                                Eliminar adeudo
                                                            </button>

                                                            <small v-if="!canEditExtraDue(buy)" class="dropdown-help text-muted">
                                                                Un adeudo pagado o con historial de CFDI no puede
                                                                editarse ni eliminarse desde este listado.
                                                            </small>

                                                            <button v-if="getPaidAmount(buy) > 0" type="button"
                                                                class="dropdown-item"
                                                                @click="showExtraPaymentsHistory(buy)">
                                                                <i class="fa-solid fa-clock-rotate-left"></i>
                                                                Historial de pagos
                                                            </button>

                                                            <button v-if="!isPaid(buy)" type="button"
                                                                class="dropdown-item text-success"
                                                                @click="showBillExternalPay(buy)">
                                                                <i class="fa-solid fa-wallet"></i>
                                                                Registrar pago
                                                            </button>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>

                                <!-- ======================
                                         SIN RESULTADOS
                                    ======================= -->

                                <tr v-else>
                                    <td colspan="5" class="empty-cell">
                                        <div class="empty-state">
                                            <i class="fa-solid fa-magnifying-glass fa-3x mb-3"></i>

                                            <h5>Sin resultados</h5>

                                            <p class="text-muted mb-3">
                                                No encontramos adeudos con los filtros seleccionados.
                                            </p>

                                            <button v-if="hasActiveFilters" type="button"
                                                class="btn btn-sm btn-outline-primary" @click="resetFilters">
                                                <i class="fa-solid fa-filter-circle-xmark mr-1"></i>

                                                Limpiar filtros
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- ==============================
                         LEYENDA
                    =============================== -->

                <div class="status-legend">
                    <span>
                        <i class="status-dot dot-paid"></i>

                        Pagado
                    </span>

                    <span>
                        <i class="status-dot dot-pending"></i>

                        Pendiente
                    </span>

                    <span>
                        <i class="status-dot dot-partial"></i>

                        Pago parcial
                    </span>

                    <span>
                        <i class="status-dot dot-billed"></i>

                        Facturado
                    </span>

                    <span>
                        <i class="status-dot dot-billing-partial"></i>

                        Facturación parcial
                    </span>

                    <span class="source-legend">
                        <i class="fa-solid fa-file-contract"></i>
                        Con contrato
                    </span>

                    <span class="source-legend">
                        <i class="fa-regular fa-file-lines"></i>
                        Sin contrato
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>



<style scoped>
/*
|--------------------------------------------------------------------------
| DISEÑO
|--------------------------------------------------------------------------
| Se conserva el mismo lenguaje visual de Lista de Indivisos:
| card + filtros claros + tarjetas resumen + tabla administrativa Bootstrap.
| No se modifica lógica, eventos, endpoints ni métodos.
|--------------------------------------------------------------------------
*/

.debts-extra-page {
    padding-bottom: 20px;
}

/* =========================================
   CARD / ENCABEZADO
========================================= */

.card-header {
    padding: 16px 20px;
}

.card-title {
    font-size: 18px;
    font-weight: 600;
}

/* =========================================
   FILTROS
========================================= */

.filters-panel {
    padding: 18px 18px 3px;
    margin-bottom: 20px;

    background-color: #f8f9fa;

    border: 1px solid #e3e6e9;
    border-radius: 8px;
}

.filters-panel label {
    margin-bottom: 6px;

    color: #495057;

    font-size: 13px;
    font-weight: 600;
}

.filters-panel .form-control {
    height: 40px;

    font-size: 14px;

    border-radius: 6px;
}

.filters-panel .mx-datepicker {
    width: 100%;
}

.range-option {
    display: inline-flex;

    align-items: center;

    gap: 7px;

    color: #495057;

    font-size: 12px;
    font-weight: 600;

    cursor: pointer;
}

/* =========================================
   TARJETAS RESUMEN
========================================= */

.summary-section {
    margin-bottom: 6px;
}

.summary-card {
    display: flex;

    align-items: center;

    min-height: 85px;

    padding: 15px;

    background-color: #ffffff;

    border: 1px solid #e5e7eb;
    border-left: 4px solid #6c757d;
    border-radius: 8px;

    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.04);
}

.summary-icon {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 44px;

    width: 44px;
    height: 44px;

    margin-right: 13px;

    font-size: 18px;

    background-color: #f1f3f5;

    border-radius: 50%;
}

.summary-label {
    display: block;

    margin-bottom: 1px;

    color: #6c757d;

    font-size: 12px;

    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.summary-value {
    display: block;

    color: #212529;

    font-size: 24px;
    line-height: 1.1;
}

.summary-money {
    font-size: 20px;
}

.summary-total {
    border-left-color: #6c757d;
}

.summary-pending {
    border-left-color: #ffc107;
}

.summary-paid {
    border-left-color: #28a745;
}

.summary-amount {
    border-left-color: #4b72d9;
}

/* =========================================
   TABLA
   MISMO PATRÓN DE LISTA DE INDIVISOS
========================================= */

.table-container {
    overflow: hidden;

    background-color: #ffffff;

    border: 1px solid #dee2e6;
    border-radius: 8px;
}

.table-responsive {
    max-height: 68vh;

    overflow: auto;
}

.debts-table-compact {
    width: 100%;
    min-width: 1180px;

    margin-bottom: 0;

    table-layout: fixed;
}

.debts-table-compact thead th {
    position: sticky;

    top: 0;

    z-index: 5;

    padding: 12px 8px;

    vertical-align: middle;

    color: #343a40;

    background-color: #f1f3f5;

    border-bottom: 2px solid #d9dde1;

    font-size: 12px;
    font-weight: 700;
}

.debts-table-compact tbody td {
    padding: 11px 8px;

    vertical-align: middle;
}

.debts-table-compact tbody tr {
    transition: background-color 0.15s ease;
}

.debts-table-compact tbody tr:hover {
    background-color: #f8fafc !important;
}

/* =========================================
   COLUMNAS
========================================= */

.debts-table-compact .column-id {
    width: 105px;
}

.debts-table-compact .column-data {
    width: 400px;

    text-align: left;
}

.debts-table-compact .column-date {
    width: 150px;
}

.debts-table-compact .column-payment {
    width: 460px;

    text-align: left;
}

/* =========================================
   ID / TIPO DE REGISTRO
========================================= */

.debt-id-card {
    display: flex;

    flex-direction: column;
    align-items: center;
}

.debt-id {
    color: #343a40;

    font-size: 14px;
    font-weight: 700;
}

.debt-contract-id {
    display: block;

    margin-top: 3px;

    color: #6c757d;

    font-size: 10px;
}

.source-badge {
    display: inline-flex;

    align-items: center;

    margin-top: 5px;

    padding: 4px 8px;

    border: 1px solid #e2e6ea;
    border-radius: 999px;

    font-size: 9px;
    font-weight: 600;

    white-space: nowrap;
}

.source-badge--contract {
    color: #1d4e89;

    background-color: #e9f0ff;
}

.source-badge--without {
    color: #59636e;

    background-color: #f1f3f5;
}

/* =========================================
   COLUMNA DATOS
========================================= */

.debt-data {
    min-width: 0;
}

.debt-data-header {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 12px;

    margin-bottom: 8px;
}

.debt-property {
    overflow: hidden;

    min-width: 0;

    color: #343a40;

    font-size: 13px;
    font-weight: 600;

    text-overflow: ellipsis;
    white-space: nowrap;
}

.debt-property i {
    color: #6c757d;
}

.debt-property--without {
    color: #59636e;
}

/* =========================================
   CLIENTE
========================================= */

.debt-client {
    display: flex;

    align-items: center;

    margin-bottom: 8px;
}

.client-avatar {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 32px;

    width: 32px;
    height: 32px;

    margin-right: 8px;

    color: #ffffff;

    background-color: #596780;

    border-radius: 50%;

    font-size: 11px;
    font-weight: 700;
}

.client-avatar-small {
    flex-basis: 29px;

    width: 29px;
    height: 29px;

    font-size: 10px;
}

.client-avatar-empty {
    background-color: #adb5bd;
}

.debt-client-empty {
    opacity: 0.8;
}

.debt-client-information {
    min-width: 0;
}

.debt-client-information strong {
    display: block;

    overflow: hidden;

    max-width: 520px;

    color: #495057;

    font-size: 12px;
    font-weight: 600;

    text-overflow: ellipsis;
    white-space: nowrap;
}

.debt-client-information small {
    font-size: 10px;
}

/* =========================================
   INDIVISOS
========================================= */

.debt-departments {
    display: flex;

    flex-wrap: wrap;

    gap: 5px;

    margin-bottom: 8px;
}

.debt-department {
    display: inline-flex;

    align-items: center;

    padding: 4px 7px;

    color: #59636e;

    background-color: #f1f3f5;

    border: 1px solid #e2e6ea;
    border-radius: 5px;

    font-size: 10px;
    font-weight: 600;
}

.debt-department small {
    margin-left: 3px;

    color: #8a939c;

    font-size: 9px;
}

/* =========================================
   DESCRIPCIÓN
========================================= */

.debt-description {
    margin-bottom: 8px;

    padding: 7px 9px;

    background-color: #f8f9fa;

    border: 1px solid #e9ecef;
    border-radius: 5px;
}

.debt-description-label {
    margin-bottom: 2px;

    color: #6c757d;

    font-size: 9px;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.25px;
}

.debt-description-text {
    display: -webkit-box;

    overflow: hidden;

    color: #495057;

    font-size: 11px;
    line-height: 1.4;

    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

/* =========================================
   CONCEPTOS
========================================= */

.debt-concepts {
    padding: 7px 9px;

    background-color: #f8f9fa;

    border: 1px solid #e9ecef;
    border-radius: 5px;
}

.debt-concepts-header {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 10px;

    padding-bottom: 5px;

    border-bottom: 1px solid #e9ecef;
}

.debt-concepts-title {
    color: #6c757d;

    font-size: 9px;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.25px;
}

.debt-concepts-count {
    color: #8a939c;

    font-size: 9px;
}

.debt-concepts-list {
    width: 100%;
}

.debt-concept-row {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 15px;

    padding: 5px 0;

    border-bottom: 1px solid #eceff2;
}

.debt-concept-description {
    display: block;

    overflow: hidden;

    flex: 1;

    color: #495057;

    font-size: 11px;

    text-overflow: ellipsis;
    white-space: nowrap;
}

.debt-concept-index {
    margin-right: 3px;

    color: #9aa2aa;

    font-size: 10px;
}

.debt-concept-amount {
    flex-shrink: 0;

    color: #343a40;

    font-size: 11px;
    font-weight: 600;

    white-space: nowrap;
}

.debt-concepts-subtotal {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 12px;

    padding-top: 7px;

    color: #495057;

    font-size: 10px;
    font-weight: 600;
}

.debt-concepts-subtotal strong {
    color: #212529;

    font-size: 12px;

    white-space: nowrap;
}

/* =========================================
   ESTATUS
========================================= */

.status-badge {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    min-width: 88px;

    padding: 5px 8px;

    font-size: 10px;
    font-weight: 600;

    border-radius: 15px;
}

.debt-status {
    flex-shrink: 0;
}

.debt-status--id {
    margin-top: 8px;
}

.badge-paid {
    color: #155724;

    background-color: #d4edda;
}

.badge-pending {
    color: #856404;

    background-color: #fff3cd;
}

/* =========================================
   FECHA
========================================= */

.debt-date {
    display: flex;

    align-items: center;
    justify-content: center;

    gap: 8px;

    text-align: left;
}

.debt-date-icon {
    display: flex;

    align-items: center;
    justify-content: center;

    flex: 0 0 32px;

    width: 32px;
    height: 32px;

    color: #6c757d;

    background-color: #f1f3f5;

    border-radius: 6px;
}

.debt-date strong {
    display: block;

    color: #495057;

    font-size: 12px;
    font-weight: 600;
}

.debt-date small {
    margin-top: 2px;

    font-size: 9px;
}

/* =========================================
   PAGO / RESUMEN
========================================= */

.payment-panel {
    display: flex;

    flex-direction: column;

    gap: 10px;
}

.payment-panel-main {
    padding: 10px 11px;

    background-color: #f8f9fa;

    border: 1px solid #e9ecef;
    border-radius: 8px;
}

.payment-panel-top {
    display: flex;

    align-items: flex-start;
    justify-content: space-between;

    gap: 12px;

    margin-bottom: 10px;
}

.payment-total-box {
    min-width: 0;
}

.payment-section-label {
    display: block;

    margin-bottom: 2px;

    color: #8a939c;

    font-size: 9px;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.25px;
}

.payment-total-value {
    color: #212529;

    font-size: 18px;
    font-weight: 700;

    white-space: nowrap;
}

.payment-amount-grid {
    display: grid;

    grid-template-columns: repeat(2, minmax(0, 1fr));

    gap: 8px;

    min-width: 230px;
}

.payment-amount-item {
    padding: 7px 9px;

    border-radius: 7px;

    border: 1px solid #e5e7eb;
}

.payment-amount-item small {
    display: block;

    margin-bottom: 2px;

    color: #8a939c;

    font-size: 8px;
    font-weight: 700;

    text-transform: uppercase;
}

.payment-amount-item strong {
    display: block;

    color: #343a40;

    font-size: 11px;
    font-weight: 700;

    white-space: nowrap;
}

.payment-amount-item--paid {
    background-color: #eff9f1;
}

.payment-amount-item--paid strong {
    color: #218838;
}

.payment-amount-item--pending {
    background-color: #fffdf4;
}

.payment-progress-wrap {
    margin-bottom: 10px;
}

.payment-progress-header {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 10px;

    margin-bottom: 5px;
}

.payment-progress-percent {
    color: #6c757d;

    font-size: 10px;
    font-weight: 700;
}

.payment-progress {
    position: relative;

    width: 100%;
    height: 8px;

    overflow: hidden;

    background-color: #e6e9ed;

    border-radius: 999px;
}

.payment-progress-bar {
    height: 100%;

    border-radius: 999px;

    transition: width 0.2s ease;
}

.payment-progress-bar--pending {
    background-color: #ffc107;
}

.payment-progress-bar--partial {
    background-color: #4b72d9;
}

.payment-progress-bar--paid {
    background-color: #28a745;
}

.payment-concepts-card {
    padding: 9px 10px;

    background-color: #ffffff;

    border: 1px solid #eceff2;
    border-radius: 7px;
}

.payment-concepts-header {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 10px;

    padding-bottom: 5px;

    border-bottom: 1px solid #e9ecef;
}

.payment-concepts-title {
    color: #6c757d;

    font-size: 9px;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.25px;
}

.payment-concepts-count {
    color: #8a939c;

    font-size: 9px;
}

.payment-concepts-list {
    width: 100%;
}

.payment-concept-row {
    display: flex;

    align-items: center;
    justify-content: space-between;

    gap: 15px;

    padding: 5px 0;

    border-bottom: 1px solid #eceff2;
}

.payment-concept-row:last-child {
    border-bottom: 0;
}

.payment-concept-description {
    display: block;

    overflow: hidden;

    flex: 1;

    color: #495057;

    font-size: 11px;

    text-overflow: ellipsis;
    white-space: nowrap;
}

.payment-concept-index {
    margin-right: 3px;

    color: #9aa2aa;

    font-size: 10px;
}

.payment-concept-amount {
    flex-shrink: 0;

    color: #343a40;

    font-size: 11px;
    font-weight: 600;

    white-space: nowrap;
}

.payment-panel-actions {
    display: flex;

    justify-content: center;
}

.badge-partial {
    color: #1d4e89;

    background-color: #dbeafe;
}


/* =========================================
   ESTADO DE FACTURACIÓN
========================================= */

.billing-state {
    display: flex;

    flex-direction: column;
    align-items: center;

    gap: 3px;

    margin-top: 7px;
}


.billing-badge {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    min-width: 88px;

    padding: 4px 7px;

    border: 1px solid transparent;
    border-radius: 999px;

    font-size: 9px;
    font-weight: 600;

    white-space: nowrap;
}


.billing-badge--pending {
    color: #6c757d;

    background-color: #f1f3f5;

    border-color: #e1e5e9;
}


.billing-badge--partial {
    color: #856404;

    background-color: #fff3cd;

    border-color: #f2d98b;
}


.billing-badge--billed {
    color: #23855d;

    background-color: #e8f7ef;

    border-color: #bee8d4;
}


.billing-badge--foreign {
    color: #304d7d;

    background-color: #eef3fb;

    border-color: #d6e1f1;
}


.billing-state__detail {
    color: #7b8494;

    font-size: 8px;
    line-height: 1.2;

    white-space: nowrap;
}


.concept-billing-dot {
    display: inline-block;

    flex: 0 0 7px;

    width: 7px;
    height: 7px;

    margin-right: 6px;

    border-radius: 50%;
}


.concept-billing-dot--billed {
    background-color: #28a745;
}


.concept-billing-dot--pending {
    background-color: #adb5bd;
}


.payment-concept-right {
    display: flex;

    flex-direction: column;
    align-items: flex-end;

    flex-shrink: 0;
}


.payment-concept-billing {
    display: block;

    margin-top: 1px;

    font-size: 8px;
    font-weight: 600;

    line-height: 1.2;
}


.payment-concept-billing--billed {
    color: #23855d;
}


.payment-concept-billing--pending {
    color: #8a939c;
}


.dropdown-count-badge {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    min-width: 17px;
    height: 17px;

    margin-left: auto;
    padding: 0 5px;

    color: #304d7d;

    background-color: #eef3fb;

    border-radius: 999px;

    font-size: 9px;
    font-weight: 700;
}

/* =========================================
   TOTAL / ACCIONES
========================================= */

.debt-total {
    display: flex;
}

.debt-options {
    margin-top: 0;
}

.debt-options>.btn {
    min-width: 104px;

    padding: 5px 9px;

    font-size: 11px;

    border-radius: 5px;
}

.debt-options-menu {
    min-width: 215px;

    padding: 5px 0;

    border: 1px solid #dee2e6;

    box-shadow: 0 7px 18px rgba(0, 0, 0, 0.1);
}

.debt-options-menu .dropdown-item {
    display: flex;

    align-items: center;

    width: 100%;

    padding: 8px 13px;

    color: #495057;

    background-color: transparent;

    border: 0;

    font-size: 12px;

    text-align: left;
}

.debt-options-menu .dropdown-item:hover:not(:disabled),
.debt-options-menu .dropdown-item:focus:not(:disabled) {
    background-color: #f5f7fa;
}

.debt-options-menu .dropdown-item:disabled {
    cursor: not-allowed;

    opacity: 0.45;
}

.debt-options-menu .dropdown-item i {
    width: 21px;

    margin-right: 6px;

    color: #6c757d;

    text-align: center;
}

.debt-options-menu .dropdown-item.text-success i {
    color: #28a745;
}

.debt-options-menu .dropdown-item.text-danger i {
    color: #dc3545;
}

.dropdown-help {
    display: block;

    padding: 5px 13px 3px;

    font-size: 9px;
    line-height: 1.35;
}

/* =========================================
   ESTADO DE FILAS
========================================= */

.row-paid {
    background-color: #f7faf8;
}

.row-partial {
    background-color: #f7f9fe;
}

.row-pending {
    background-color: #fffdf4;
}

.row-paid td:first-child {
    border-left: 4px solid #28a745;
}

.row-partial td:first-child {
    border-left: 4px solid #4b72d9;
}

.row-pending td:first-child {
    border-left: 4px solid #ffc107;
}

/* =========================================
   CARGA / VACÍO
========================================= */

.loading-cell,
.empty-cell {
    height: 250px;

    padding: 0 !important;
}

.loading-content,
.empty-state {
    padding: 50px 20px;

    text-align: center;
}

.loading-content i {
    color: #6c757d;
}

.empty-state i {
    color: #adb5bd;
}

/* =========================================
   LEYENDA
========================================= */

.status-legend {
    display: flex;

    flex-wrap: wrap;
    justify-content: flex-end;

    gap: 18px;

    padding-top: 14px;

    color: #6c757d;

    font-size: 12px;
}

.status-legend span {
    display: inline-flex;

    align-items: center;
}

.status-dot {
    display: inline-block;

    width: 9px;
    height: 9px;

    margin-right: 6px;

    border-radius: 50%;
}

.dot-paid {
    background-color: #28a745;
}

.dot-pending {
    background-color: #ffc107;
}

.dot-partial {
    background-color: #4b72d9;
}


.dot-billed {
    background-color: #28a745;
}


.dot-billing-partial {
    background-color: #d99b24;
}


.source-legend i {
    width: 14px;

    margin-right: 5px;

    color: #7b8490;

    text-align: center;
}

/* =========================================
   RESPONSIVE
========================================= */

@media (max-width: 991px) {
    .debts-table-compact {
        min-width: 1090px;
    }

    .debts-table-compact .column-date {
        width: 145px;
    }

    .debts-table-compact .column-payment {
        width: 430px;
    }

    .debt-client-information strong {
        max-width: 300px;
    }
}

@media (max-width: 767px) {
    .card-header {
        padding: 14px;
    }

    .card-body {
        padding: 14px;
    }

    .filters-panel {
        padding: 15px 15px 0;
    }

    .summary-card {
        min-height: 75px;
    }

    .status-legend {
        justify-content: flex-start;
    }

    .debts-table-compact {
        min-width: 1040px;
    }

    .debts-table-compact .column-id {
        width: 98px;
    }

    .debts-table-compact .column-date {
        width: 140px;
    }

    .debts-table-compact .column-payment {
        width: 400px;
    }

    .debt-client-information strong {
        max-width: 230px;
    }

    .debt-total-value {
        font-size: 15px;
    }

    .debt-options>.btn {
        min-width: auto;
    }
}

.column-actions {
    width: 150px;
}
</style>
